/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignInResponseDto } from '../../models/sign-in-response-dto';
import { SignInSixbidRequestDto } from '../../models/sign-in-sixbid-request-dto';

export interface SignInSixbid$Params {
  'X-API-Version'?: string;
      body: SignInSixbidRequestDto
}

export function signInSixbid(http: HttpClient, rootUrl: string, params: SignInSixbid$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
  const rb = new RequestBuilder(rootUrl, signInSixbid.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInResponseDto>;
    })
  );
}

signInSixbid.PATH = '/api/session/sixbid';
